module.exports = __webpack_public_path__ + "static/media/exit-to-app.104347aa.svg";